import {
  bool, number, object, string, func, array,
} from 'prop-types';
import {
  useState, useEffect, useContext, useRef,
} from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import {
  Row, Col, Button, Rate, Spin, Skeleton, notification, Modal,
} from 'antd';
import { useInView } from 'react-intersection-observer';

import ProductInfoSection from 'components/productInfoSection';
import { getCountryFromMarket } from 'utils/translations';
import {
  formatPrice, setCookie, obtainVoucherPrices,
  getCookie, COOKIES, eraseCookie,
  getLang, getMarket, handleStorage, nnormalSizesMap, getFixedPrice,
} from 'utils/helpers';

import Product from 'components/product';
import RecommendedBag from 'components/recommendedBag';
import {
  addToBag, getCrossSelling, getProduct, getCart, retrieveBag,
} from 'actions/products';
import { useI18n } from 'context/i18n';
import { userContext } from 'context/user';
import { dataLayerCartClick, dataLayerHandleEvent } from 'utils/dataLayers';

import { IS_CAMPER, IS_NNORMAL } from 'utils/constants/system';
import { MAX_BAG_LENGTH, FAMILIES } from 'utils/constants/products';
import { BAZAAR_VOICE_MARKETS } from 'utils/constants/ux';
import { AUTO_BONDS } from 'utils/constants/cookies';
import { SIZE_GUIDE_WITH_MODELS } from 'utils/constants/sizes';

import { setBagCookies } from 'utils/bag';
import { ProductShare } from 'components/productShare';
import styles from './style.module.css';

const ProgressiveImg = dynamic(() => import('components/base/image').then((mod) => mod.ProgressiveImg));
const SizesList = dynamic(() => import('components/sizesList'));
const ONESVG = dynamic(() => import('components/iconsSVG/one').then((mod) => mod.ONESVG));
const RateSVG = dynamic(() => import('components/iconsSVG/rate').then((mod) => mod.RateSVG));

const SizesGuide = dynamic(() => import('components/sizesGuide').then((mod) => mod.default));
const GiftCard = dynamic(() => import('components/giftCard'));
const NotifyMeButton = dynamic(() => import('components/notifyMeButton'));
const AddToBagBtn = dynamic(() => import('./addToBagBtn').then((mod) => mod.default));
const AddToWishlistBtn = dynamic(() => import('./addToWishlistBtn').then((mod) => mod.default));
const AfterpayButton = dynamic(() => import('components/checkout/afterpayButton').then((mod) => mod.default));
// const KboixSoles = dynamic(() => import('components/kboix/soles').then((mod) => mod.KboixSoles));

const displayPrice = (prices, market) => {
  if (prices && prices.currentFormated && prices.currency) {
    return formatPrice(prices.currentFormated, market);
  }
  return null;
  // return <p className={styles.smallText}>{roundAndFormatPrice(0, market)}</p>;
};

const ProductPurchaseCol = ({
  productSheet, averageRate, hasReviews, locale, product, market, isCamperOne, onCustomize, isGiftCard, isSock,
  onClickReviews, isFullScreen, isMobile, columnSizes, recalculating, voucherApplied, voucherPriceText, isRoku,
}) => {
  const {
    t, bagLength, profileData, setBagLength, bagHasMembersOnlyProduct, bag, setBag,
    setRecommendedProductsForBag, setPromoLabel, setPromoLabelType,
  } = useI18n();
  const {
    userData, setReadyForVouchers, contextFilters, activatedPrevouchers,
  } = useContext(userContext);
  const { config } = profileData;
  const showFreeShipping = config?.show_free_shipping || false;
  const showGiftPurchase = config?.show_gift_purchase || false;
  const buttonBagRef = useRef(null);
  const router = useRouter();
  const { ref, inView } = useInView({ threshold: 1 });
  const availablePrice = productSheet.prices && productSheet.prices?.current;
  const {
    isAccessory, sizes, code, prices, camperlab, notifyMe,
  } = productSheet;
  const isAvailableAccesory = isAccessory && availablePrice && sizes && sizes.length > 0 ?
    sizes.filter((size) => size.available).length > 0 : false;
  const isMembersOnly = productSheet?.membersOnly || false;
  const defaultSelectedSize = isAccessory && isAvailableAccesory ? sizes[0]?.value ?? ' ' : undefined;
  const { query } = router;

  // TEST DIM, CUANDO INTEGREMOS EN BASE A LA INFO DEL PRODUCTO LO HAREMOS COMO EN CAMPER ONE
  // EN BASE A LA PRODUCT SHEET
  const { testDim } = query;
  const [ isMouseOverCartBtn, setIsMouseOverCartBtn ] = useState(false);
  const [ cartError, setCartError ] = useState(false);
  const [ selectedSize, setSelectedSize ] = useState(isAccessory && isAvailableAccesory ? sizes[0]?.value ?? ' ' : undefined);
  const [ loading, setLoading ] = useState(false);
  const [ modalMembersOnlyVisible, setModalMembersOnlyVisible ] = useState(false);
  const [ showRokuWarning, setShowRokuWarning ] = useState(false);
  const [ failedRokus, setFailedRokus ] = useState([]);
  // const [ kboixSoles, setKboixSoles ] = useState([]);
  const reviewsCount = hasReviews ? productSheet.reviewStatistics?.TotalReviewCount : 0;
  const country = getCountryFromMarket(market);
  const limitedSizes = sizes && sizes.filter((size) => size.quantity === 1).map((item) => item.value);
  const selectedSizeItem = sizes && sizes.filter((size) => size?.value === selectedSize);
  const selectedSizePrice = selectedSizeItem.length && selectedSizeItem[0].price?.current;
  const totalPrice = prices !== null ? selectedSizePrice || prices?.current || prices?.previous : null;
  const [ notificationApi, notificationContextHolder ] = notification.useNotification();
  const availableSizes = sizes.filter((item) => item.available).map((size) => size.value);

  const handleSelectSize = (size) => {
    setSelectedSize(size);

    // puesto que productSheet no tiene control sobre selectedSize
    // necesito hacer esto para leer selectedSize mientras calculo vouchers
    // así puedo cambiar los perSize una vez se selecciona la talla
    window.selectedSizeForVoucher = size;
    setReadyForVouchers(size);

    setCartError(false);

    dataLayerHandleEvent({
      event: 'item_size_selection',
      event_category: 'product detail',
      event_detail_1: 'size selection',
      event_detail_2: size,
    });

    dataLayerHandleEvent({
      event: 'sizeSelected',
      eventCat: 'Selligent',
      eventLbl: size,
    });
  };

  const redirectToBag = () => {
    const colorBlack = getComputedStyle(document.body).getPropertyValue('--color-black').trim();
    const colorWhite = getComputedStyle(document.body).getPropertyValue('--color-white').trim();
    buttonBagRef.current.querySelector('p').style.opacity = '0.5';
    buttonBagRef.current.style.pointerEvents = 'none';
    buttonBagRef.current.style.color = colorBlack;
    buttonBagRef.current.style.backgroundColor = colorWhite;
    buttonBagRef.current.style.borderColor = colorWhite;
    buttonBagRef.current.style.boxShadow = 'none';
    buttonBagRef.current.querySelector('.ant-spin').style.display = 'inline';
    buttonBagRef.current.querySelector('.ant-spin').style.position = 'absolute';
    window.location.assign(`${window.location.origin}/${locale}/bolsa`);
  };

  const addToCartHandler = async ({
    payload, cookiesBagId, showJustAdded, sizeLabel, thumbnail = false, extras = null,
  }) => {
    const cookiesMarket = getCookie(COOKIES.BAG_MARKET);
    const cookiesShipment = getCookie(COOKIES.SHIPMENT);
    const cookiesBonds = getCookie(COOKIES.BONDS);
    const cookiesZip = getCookie(COOKIES.ZIP);
    const cookiesEmployeeId = getCookie(COOKIES.EMPLOYEE_ID);
    const cookiesPackstation = getCookie(COOKIES.PACKSTATION);
    const cookiesCtr = getCookie(COOKIES.IS_CTR);
    if (cookiesMarket !== market) {
      payload.hashOrderId = '';
      if (cookiesBagId) {
        eraseCookie(COOKIES.BAG);
        eraseCookie(COOKIES.BAG_DATE);
      }
      if (cookiesZip) {
        eraseCookie(COOKIES.ZIP);
      }
      if (cookiesShipment) {
        eraseCookie(COOKIES.SHIPMENT);
      }
      if (cookiesMarket !== null && cookiesBonds) {
        eraseCookie(COOKIES.BONDS, COOKIES.DOMAIN);
        eraseCookie(COOKIES.AUTO_BONDS);
      }
      if (cookiesEmployeeId) {
        eraseCookie(COOKIES.EMPLOYEE_ID);
      }
      if (cookiesPackstation) {
        eraseCookie(COOKIES.PACKSTATION);
      }
      if (cookiesCtr) {
        eraseCookie(COOKIES.IS_CTR);
      }
    }

    const [ result, crossSellingProducts ] = await Promise.all([ addToBag(payload), getCrossSelling(null, locale, payload.id) ]);
    let updatedPromoLabel = null;
    let updatedPromoLabelType = null;
    const previousGridUrl = sessionStorage.getItem('gridUrl');

    if (productSheet?.baseUrl && previousGridUrl === undefined) {
      const [ domain, fullUrl ] = productSheet?.baseUrl?.split(locale);

      try {
        const splitUrl = fullUrl.split('/').filter(Boolean);
        const gridUrl = splitUrl.slice(0, splitUrl.length - 1).join('/');
        handleStorage('setItem', 'gridUrl', `${domain}${locale}/${gridUrl}`);
      } catch (e) {
        // en caso de que algo fallase mandamos a la home
        handleStorage('setItem', 'gridUrl', `${domain}${locale}/`);
      }
    }

    dataLayerCartClick({ ...payload, productSheet }, result, false, bag);
    if (result.hashOrderId) {
      setBagCookies({ hash: encodeURI(result.hashOrderId), market });

      const { sapActive, extendedBlockSAP, shoppingCart } = result;
      if (!sapActive && !extendedBlockSAP) {
        // can't pay
        window.location.assign(`${window.location.origin}/${locale}/pedido_offline`);
      } else {
        if (extendedBlockSAP) {
          // can pay
          setCookie(COOKIES.SHIPMENT, '01', undefined, COOKIES.DOMAIN);
        }
        if (!showJustAdded) {
          window.location.assign(`${window.location.origin}/${locale}/bolsa`);
        }
        if (showJustAdded) {
          const { price } = shoppingCart[0]; // siempre es una array con un solo item
          obtainVoucherPrices({ ...shoppingCart[0], prices: price }, t, locale, contextFilters, activatedPrevouchers, false, true);
          const newBag = bag ? JSON.parse(JSON.stringify(bag)) : [];
          // handleStorage('setItem', 'justAddedItem', JSON.stringify({ ...result.shoppingCart[0], membersOnly: productSheet?.membersOnly }));
          setBag(() => {
            const n = [ { ...result.shoppingCart[0], membersOnly: productSheet?.membersOnly }, ...newBag ];
            return n;
          });
          setBagLength(() => {
            const newLength = bagLength + 1;
            return newLength;
          });

          setRecommendedProductsForBag((prev) => [ ...crossSellingProducts, ...prev ].map((item, i) => ({ ...item, order: i })));
          const style = {
            width: !isMobile ? '360px' : '100%',
            maxWidth: !isMobile ? '360px' : '100vw',
            right: '-24px',
          };
          if (isMobile) {
            style.minWidth = 'calc(100vw - 17px)';
          }
          let parsedTarget = 'M';
          if (market === 'US') {
            parsedTarget = 'US';
          } else if ([ 'M', 'W' ].includes(product.target)) {
            parsedTarget = product.target;
          }

          if (showFreeShipping) {
            updatedPromoLabel = result?.freeShippingLabel || null;
          }
          let promoLabelObtained = false;
          if (showGiftPurchase) {
            updatedPromoLabel = result?.gwplabel || result?.freeShippingLabel || null;
            if (result?.gwplabelObtained && result?.gwplabelObtained !== '') {
              updatedPromoLabel = result?.gwplabelObtained;
              promoLabelObtained = true;
              updatedPromoLabelType = 'obtained';
            }
          }
          const sizeLabelCamper = IS_CAMPER && market === 'US' && [ FAMILIES.SHOES, FAMILIES.ACCESSORIES ].includes(Number(productSheet.family)) ? `${sizeLabel} US / ${selectedSize} EU` : `${country} ${sizeLabel}`;
          // Si se quita en un futuro para nnormal, quitar tambien los estilos de la notificacion
          if (IS_NNORMAL) {
            notificationApi.open({
              message: t('ficha.producto', 'notificacion.bolsa', 'Just added to bag'),
              duration: 6,
              key: 'addedToBagNotification',
              description:
                  <div>
                    <ul className={styles.bagAddedItemUl}>
                      <li className={styles.bagAddedItem}>
                        { thumbnail ? <img src={thumbnail} /> : <img src={productSheet.imageBagMini} />}
                        <ul className={styles.bagAddedItemContent}>
                          <li className={styles.bagAddedTitle}>{productSheet.brand}</li>
                          <li className={styles.bagAddedCode}>{IS_NNORMAL ? productSheet.codeDescription : productSheet.code}</li>
                          {IS_NNORMAL ? (
                            <li className={styles.bagAddedSize}>{nnormalSizesMap?.[parsedTarget]?.[selectedSize] ?? sizeLabel}</li>
                          ) : (
                            <li className={styles.bagAddedSize}>{sizeLabelCamper}</li>
                          )}
                          <li className={styles.bagAddedPrice}>{price.currentFormated}</li>
                          {price.previous && price.previousFormated && price.previous > price.current &&
                            <li className={styles.discountPriceText}>
                              <del className={styles.discountPricePrevious} data-fp={getFixedPrice(market, profileData, price?.previous)}>
                                {price !== null && price.pricePerSize && !availableSizes.includes(selectedSize) ? `${t('listado.productos', 'desde', 'From')} ` : '' }
                                {price !== null && price.previousFormated &&
                                  formatPrice(price?.previousFormated, market)
                                }
                              </del>
                              <span className={`${voucherApplied ? styles.discountByVoucher : styles.discountPercent} green`}>{price?.discount ? `-${price.discount}%` : ''}</span>
                            </li>
                          }
                        </ul>
                      </li>
                        {/* {Array.isArray(extras) && extras.length > 0 ? extras.map((extra) => {
                          const extraInResults = extraResults.find((r) => r.shoppingCart[0].productId === extra.id)?.shoppingCart?.[0];
                          return (
                            <li className={styles.bagAddedItem} key={`extra-bag-${extra.id}`}>
                              <div className={styles.extraImage}>
                                <img src={extra.viewData.image} alt="" />
                              </div>
                              <ul className={styles.bagAddedItemContent} >
                                <li className={styles.bagAddedTitle}>{extra.viewData.name}</li>
                                <li className={styles.bagAddedCode}>{extra.viewData.description}</li>
                                <li className={styles.bagAddedSize}>{extra.sizeLabel}</li>
                                {extraInResults ? <li className={styles.bagAddedPrice}>{extraInResults.price.currentFormated}</li> : null}
                              </ul>
                            </li>
                          );
                        }) : null} */}
                    </ul>
                    {
                      IS_CAMPER && <RecommendedBag recommendedProducts={crossSellingProducts} />
                    }
                    {updatedPromoLabel &&
                      <p className={styles.promoLabel}>{promoLabelObtained ? '' : updatedPromoLabel}</p>
                    }
                    <Button ref={buttonBagRef} type="primary" onClick={redirectToBag} className={styles.btnGoPurchase} block>
                      <>
                        <Spin spinning className={styles.spin} />
                        <p>{`${t('ficha.producto', 'notificacion.bolsa.ver.bolsa', 'View bag')} (${bagLength + 1 + (extras?.length ?? 0)})`}</p>
                      </>
                    </Button>
                    {
                      IS_CAMPER && <Button id="minibag-continue-shopping" type="default" onClick={() => { notification.destroy('addedToBagNotification'); }} className={`${styles.btnGoPurchase} ${styles.btnContinueShopping}`} block>
                      <>
                        <p>{t('newsletter', 'seguir.comprando', 'Continue Shopping')}</p>
                      </>
                    </Button>
                    }
                  </div>,
              onClick: () => {
                // console.log('Notification Clicked!');
              },
              className: styles.addToCartNotification,
              style,
              btn: null,
            });
          }
          setLoading(false);
          setPromoLabel(updatedPromoLabel);
          setPromoLabelType(updatedPromoLabelType);
        }
      }
      // [TODO]: que quiten la cache de bolsa.json en integra
      // router.push('/bolsa');
    } else {
      setLoading(false);
      // [TODO]: handle error
      // eslint-disable-next-line no-alert
      alert('No se puede procesar el pedido en este momento');
    }
  };

  const handleClickAddToCartBtn = async (showJustAdded = false, userIdentified = false) => {
    const isUserIdentified = getCookie(COOKIES.SELLIGENT_USRHASH) || getCookie(COOKIES.MEMBERS_ONLY_SUBSCRIBED) || userIdentified || bagHasMembersOnlyProduct || userData !== null;
    if (!availableSizes.includes(selectedSize)) {
      const message = !isAccessory ? 'elige.talla' : 'producto.nodisponible';
      setCartError(t('ficha.producto', message));
      if (!isAccessory && isMobile) {
        document.querySelector('#row-sizes').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    // } else if (IS_NNORMAL && productSheet.kboix === true && kboixSoles.length <= 1) {
    //   // must select at least two soles to purchase kboix product
    //   setCartError(t('kboix.soles', 'must.select.soles', 'You must select a sole'));
    } else if (bagLength >= MAX_BAG_LENGTH) {
      setCartError(t('ficha.producto', 'alcanzado.limite.bolsa', 'The product could not be added. You have reached the limit of products in your shopping cart.'));
    } else if (isMembersOnly && !isUserIdentified) {
      setModalMembersOnlyVisible(true);
    } else {
      const cookiesBagId = getCookie(COOKIES.BAG);
      setLoading(showJustAdded ? 'B' : 'A');
      const sizeLabel = !isAccessory ? sizes.filter((size) => size?.value === selectedSize)[0]?.label : selectedSize;
      const autoVoucher = getCookie(COOKIES.AUTO_BONDS) || '';
      const voucher = getCookie(COOKIES.BONDS) || '';
      const voucherDiscount = IS_CAMPER && autoVoucher && autoVoucher === AUTO_BONDS.APPLY;
      const pricesPayload = prices;
      const discountStrToNumber = prices?.discountStr ? Number(prices?.discountStr?.replace(/\D/g, '')) : 0;
      if (discountStrToNumber > prices.discount) { // tenemos que enviar el discount que mas beneficie
        pricesPayload.discount = discountStrToNumber;
      }
      const payload = {
        id: code,
        price: pricesPayload,
        profile: {
          countryId: getMarket(locale),
          languageId: getLang(locale),
        },
        size: selectedSize,
        sizeLabel,
        gender: productSheet.realTarget || productSheet.target || '',
        thumbnail: productSheet.imageBag || '', // en ocasiones queda como null y causa un error
      };
      if (voucherDiscount) {
        payload.voucher = voucher;
      }
      if (cookiesBagId) {
        payload.hashOrderId = decodeURI(cookiesBagId);
      }

      let camperOneJSON = null;
      if (isCamperOne || isRoku) {
        if (window.camperOneGetJson) {
          // old version camper one no wait
          try {
            camperOneJSON = window.camperOneGetJson();
          } catch (e) {
            // failed because jsonBO is undefined since
            // user comes from mobile and never customized (didn't load plugin)
            camperOneJSON = productSheet.camperone.jsonConfig;
          }

          payload.camperone = {
            jsonConfig: camperOneJSON,
          };

          addToCartHandler({
            payload, cookiesBagId, showJustAdded, sizeLabel,
          });
        } else if (window.customDIM?.api) {
          // new dim version, wait for getJSON to finish
          try {
            window.customDIM.api.getCaptureAndJSON(
              512, 512, 'ffffff',
              async (data) => {
                const viewUrl = data?.urlVistas;
                const base64Image = data?.image;

                data.urlVistas = [ viewUrl ];

                if (base64Image) {
                  payload.image = base64Image;
                }

                delete data.image;

                if (isRoku) {
                  const { piezas } = data;
                  const addMultiplePayload = piezas
                    .filter((pieza) => pieza?.customizable === true)
                    .map((item) => ({
                      sku: item.material[0].idMaterialEshop,
                      size: selectedSize,
                    }));

                  const addToCartMultipleResult = await window.addToCartMultiple(addMultiplePayload, true, bag);
                  const bagID = getCookie(COOKIES.BAG);

                  try {
                    const failed = !addToCartMultipleResult[0];
                    let succeededProducts = addToCartMultipleResult[1]?.filter((item) => item.status === 'OK');

                    if (failed) {
                      const failedProducts = addToCartMultipleResult[1].filter((item) => item.status !== 'OK');
                      const failedRokusWithInfo = [];
                      const getProductPromises = [];

                      failedProducts.forEach((failedItem) => {
                        getProductPromises.push(getProduct({
                          lang: locale,
                          productCode: failedItem.sku,
                          target: productSheet.realTarget || productSheet.target,
                        }).then((productInfo) => {
                          if (productInfo?.productSheet) {
                            failedRokusWithInfo.push(productInfo.productSheet);
                          }
                        }));
                      });

                      await Promise.all(getProductPromises);
                      // quitar del carrito los que hayan funcionado
                      // hacemos un get cart primero
                      // quitamos todos los que tengamos en la lista que coincidan

                      setFailedRokus(failedRokusWithInfo);

                      if (succeededProducts?.length > 0) {
                        const currentBag = await retrieveBag({
                          payload: {
                            hashOrderId: bagID,
                            profile: {
                              countryId: market,
                              languageId: getLang(locale),
                            },
                          },
                        });

                        const productsCurrentlyInBag = currentBag?.shoppingCart;

                        if (productsCurrentlyInBag?.length > 0) {
                          const newBag = [ ...productsCurrentlyInBag ].filter((item) => {
                            // devolver false para los que esten en succeeded
                            const successfulProduct = succeededProducts.find((succeededItem) => succeededItem.sku === item.productId && succeededItem.size === item.size);

                            if (successfulProduct !== undefined) {
                              // encontrado el producto, lo quitamos de la lista y filtramos
                              succeededProducts = succeededProducts.filter((itemToCheck) => !(itemToCheck.sku === successfulProduct.sku && itemToCheck.size === successfulProduct.size));
                              return false;
                            }

                            return true;
                          });

                          console.log('new bag is', newBag);
                          const employeeId = getCookie(COOKIES.EMPLOYEE_ID) || '';
                          const zipCode = getCookie(COOKIES.ZIP) || '';
                          const tax = zipCode && zipCode !== '' ? { zipcode: zipCode } : {};

                          const newCart = await getCart({
                            lang: locale,
                            products: newBag,
                            hashOrderId: bagID,
                            employeeId,
                            bondValue: voucher,
                            tax,
                          });

                          console.log('new cart', newCart);
                        }
                      }
                    }

                    setShowRokuWarning(failed);

                    const updateForBag = [
                      ...bag,
                      ...succeededProducts.map((item) => item.shoppingCart?.[0]),
                    ];

                    setBag(updateForBag);
                    setBagLength(updateForBag.length);
                  } catch (e) {
                    console.error(e);
                  }

                  setLoading(false);
                } else {
                  payload.camperone = {
                    jsonConfig: data,
                  };

                  addToCartHandler({
                    payload, cookiesBagId, showJustAdded, sizeLabel, thumbnail: base64Image || false,
                  });
                }
              },
              (error) => {
                console.error('error', error);
                throw error;
              },
            );
          } catch (e) {
            console.error('failed to get json from dim');
            console.error(e);
            camperOneJSON = productSheet.camperone.jsonConfig;
            payload.camperone = {
              jsonConfig: camperOneJSON,
            };
            addToCartHandler({
              payload, cookiesBagId, showJustAdded, sizeLabel,
            });
          }
        }
      } else {
        // no wait
        addToCartHandler({
          payload, cookiesBagId, showJustAdded, sizeLabel,
        });
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    });
    const urlParams = new URLSearchParams(window.location.search);
    const sizeValue = urlParams.get('size');
    const sizeIsAvailable = sizes && sizes.filter((size) => size.value === sizeValue && (size.available || notifyMe)).length > 0;
    if (sizeValue && sizeIsAvailable) {
      setSelectedSize(sizeValue);
    } else {
      setSelectedSize(defaultSelectedSize);
    }
  }, []);

  const handleClickBrandProduct = (e, productBrand) => {
    e.preventDefault();
    dataLayerHandleEvent({
      event: 'eventGA',
      eventCat: 'productDetail',
      eventAct: 'selectColour',
      eventLbl: productBrand.id,
    });

    dataLayerHandleEvent({
      event: 'item_photos',
      event_category: 'product detail',
      event_detail_1: 'open',
      event_detail_2: productBrand.image,
    });

    window.location.assign(`${window.location.origin}/${locale}${productBrand.url.split(locale)[1]}`);
    // router.push(`${productBrand.url.split(locale)[1]}`);
  };

  let sizeFound = selectedSize ? sizes.find((size) => size?.value === selectedSize) : {};
  if (!sizeFound) {
    sizeFound = {};
  }

  const appmode = process.browser ? getCookie(COOKIES.APP_IPAD) === 'true' : false;

  const isPresale = productSheet.presales;

  let addToCartLabel = !isPresale ? t('ficha.producto', 'add.to.bag', 'Add to bag') : t('ficha.producto', 'add.to.bag.presale', 'PRE-ORDER');

  if (isMembersOnly) {
    addToCartLabel = `${!isPresale ? t('ficha.producto', 'members.only.shop') : t('ficha.producto', 'add.to.bag.presale')} ${t('ficha.producto', 'members.only', '(Members Only)')}`;
  }

  const priceRange = prices?.priceDiscountFromFormatted && prices?.priceDiscountToFormatted ?
    `${prices.priceDiscountFromFormatted} - ${prices.priceDiscountToFormatted}` : `${prices?.priceFromFormatted} - ${prices?.priceToFormatted}`;

  const notifymeBySize = notifyMe && productSheet?.notifyMeType === 'SIZE';

  let shouldShowSizes = availablePrice;
  let shouldShowButton = availablePrice &&
  (!productSheet.notifyMe ||
    (productSheet.notifyMe &&
      notifymeBySize &&
      (availableSizes.includes(selectedSize) || selectedSize === undefined)
    )
  );
  // si el producto tiene talla unica, es notifyMe por talla y no tiene disponibilidad, no debería mostrar nada
  if (productSheet.notifyMe && productSheet.notifyMeType === 'SIZE' && sizes.length === 1 && sizes.every((size) => !size.available)) {
    shouldShowSizes = false;
    shouldShowButton = false;
  }

  if (availableSizes.length === 0 && !productSheet?.notifyMe) {
    // NO es notifyme y no tiene disponibilidad de tallas, debería ser como si no tuviese precio
    shouldShowSizes = false;
    shouldShowButton = false;
  }

  const sizeGuideInfo = SIZE_GUIDE_WITH_MODELS.includes(productSheet.code) && productSheet.description ? productSheet.description : null;
  const isStandardNotifyMe = productSheet?.notifyMeType !== null && productSheet?.notifyMeType !== 'SIZE';
  const isBySizeWithNoSizes = !isStandardNotifyMe && availableSizes.length === 0;
  const hideFewStockMessage = isStandardNotifyMe || isBySizeWithNoSizes;
  const fixedPrice = getFixedPrice(market, profileData, prices?.current);

  const countriesWithSizeSelector = [ 'US' ];

  return (
    <Col xs={columnSizes.xs} md={columnSizes.md} lg={columnSizes.lg} className={`${styles.productInfoCol} ${testDim ? styles.productInfoDim : ''}`}>
      {notificationContextHolder}
      <div>
        <div className={styles.titleWrapper}>
          <>
            <h1 className={availablePrice ? styles.brandTitle : `${styles.brandTitle} ${styles.brandTitleNotify}`}>
              {`${productSheet.brand} `}
              {productSheet.codeDescription ? (
                <span
                  dangerouslySetInnerHTML={{ __html: productSheet.codeDescription }}
                  className={availablePrice ? styles.codeDescription : styles.codeDescriptionNotify}
                />
              ) : null}
            </h1>
            {IS_NNORMAL && productSheet?.codeFeatures &&
                <h2
                  dangerouslySetInnerHTML={{ __html: productSheet?.codeFeatures }}
                  className={`${styles.codeDescription} ${styles.codeFeatures}`}
                />
              }
            {isGiftCard && productSheet.brandProducts && productSheet.brandProducts.length > 1 &&
              <div className={styles.brandProductsRow__container}>
                <p className={styles.brandProductsRow__title}>
                  {t('ficha.producto', 'colores', 'Colores')}:
                </p>
                <div className={styles.brandProductsRow}>
                  {productSheet.brandProducts.map((productBrand, index) => productBrand.url &&
                      <div
                        key={`${productBrand.id}-${index}`}
                        className={productBrand.id !== productSheet.code ? styles.brandProductThumbCol : `${styles.brandProductThumbCol} ${styles.brandProductThumbActive}`}
                      >
                          <a
                            href={`/${locale}${productBrand.url.split(locale)[1]}`}
                            onClick={(e) => handleClickBrandProduct(e, productBrand)}
                          >
                          <ProgressiveImg
                            src={productBrand.image}
                            alt={`thumbnail image ${index} of ${productBrand.id}`}
                            otherProps={{
                              width: 60,
                              height: 60,
                              className: styles.brandThumbnail,
                              onClick: isCamperOne ? () => onCustomize(false, productBrand.id) : () => true,
                            }}
                          />
                        </a>
                      </div>)}
                  </div>
              </div>
            }
            {
              appmode && <span className={styles.productSku}>{productSheet.code}</span>
            }
            {isCamperOne && !isRoku && <ONESVG className={styles.camperONESVG} />}
            {
              !isGiftCard && <>
              {IS_CAMPER && recalculating &&
                <Skeleton.Input active loading size='small' className={styles.recalcPrice} />
              }
              {!recalculating &&
                <p
                  className={availablePrice ? `${styles.productCurrentPrice} ${styles.priceSpan}` : styles.productCurrentPriceNotify}
                  data-ge-price="data-ge-price"
                  data-fp={fixedPrice}
                >
                  {/* es horrible y me sabe mal pero la lógica es funcional y es para ir rápido */}
                  {prices !== null && prices.pricePerSize ?
                    !availableSizes.includes(selectedSize) ? priceRange : displayPrice(sizeFound.price, market) :
                    null
                  }
                  {prices !== null && !prices.pricePerSize &&
                    displayPrice(productSheet.prices, market)
                  }
                </p>
              }
              {!recalculating && availablePrice && productSheet.prices && (productSheet.prices.previous || productSheet.prices.priceDiscountFromFormatted) &&
                <p className={styles.discountPriceText}>
                  <del className={styles.discountPricePrevious} data-fp={getFixedPrice(market, profileData, productSheet?.prices?.previous)}>
                    {prices !== null && prices.pricePerSize ?
                      !availableSizes.includes(selectedSize) ? `${prices.priceFromFormatted} - ${prices.priceToFormatted}` : formatPrice(sizes.find((size) => size?.value === selectedSize)?.price?.previousFormated, market) :
                      null}
                    {prices !== null && !prices.pricePerSize &&
                      formatPrice(productSheet.prices.previousFormated, market)
                    }
                  </del>
                  <span className={`${IS_CAMPER && voucherApplied ? styles.discountFromVoucher : ''} green`}>{`${productSheet?.prices?.discountStr || `-${productSheet?.prices?.discount}%`}`}</span>
                </p>
              }
              {IS_CAMPER && !recalculating && voucherApplied && productSheet.prices?.previous !== undefined && productSheet.prices?.previous > productSheet.prices?.current && voucherPriceText === null &&
                <p className={styles.voucherApplied}>
                  {productSheet.prices.appliedLabel}
                </p>
              }
              {prices?.pricePerSize &&
                <p className={styles.pricePerSize}>
                  {t('listado.productos', 'final.price.acording', 'Final price acording to size')}
                </p>
              }
              </>
            }
          </>
          {!isGiftCard ?
            <>
              {IS_CAMPER && market === 'AU' && availablePrice &&
                <AfterpayButton totalPrice={totalPrice} currency={prices.currency || 'AUD'} />
              }
              {
                !camperlab && BAZAAR_VOICE_MARKETS.includes(market) && <div id="product_rating" className={styles.productRating}>
                  <div data-bv-show="rating_summary" data-bv-product-id={productSheet?.code}></div>
                </div>
              }
              {availablePrice && reviewsCount > 0 && !productSheet.recycled && !productSheet.camperlab &&
                <div
                  className={styles.rateWrapper}
                  onClick={onClickReviews}
                >
                  <Rate
                    className={styles.rateStars}
                    allowHalf
                    defaultValue={productSheet.rate}
                    value={averageRate}
                    disabled
                    character={<RateSVG />}
                  />
                  <p className={styles.rateTitle}>
                    {`${reviewsCount} ${t('ficha.producto', 'see.reviews')}`}
                  </p>
                </div>
              }
            </> :
          <GiftCard
            prices={productSheet.prices}
            locale={locale}
            productSheet={productSheet}
          />
        }
        </div>
        {!isGiftCard && productSheet.brandProducts && productSheet.brandProducts.length > 0 &&
          <div className={styles.brandProductsRow__container}>
            <p className={styles.brandProductsRow__title}>
              {t('ficha.producto', 'colores', 'Colores')}:
            </p>
            <div className={styles.brandProductsRow}>
              {productSheet.brandProducts.map((productBrand, index) => productBrand.url &&
                  <div
                    key={`${productBrand.id}-${index}`}
                    className={productBrand.id !== productSheet.code ? styles.brandProductThumbCol : `${styles.brandProductThumbCol} ${styles.brandProductThumbActive}`}
                  >
                      <a
                        href={`/${locale}${productBrand.url.split(locale)[1]}`}
                        onClick={(e) => handleClickBrandProduct(e, productBrand)}
                      >
                      <ProgressiveImg
                        src={productBrand.image}
                        alt={`thumbnail image ${index} of ${productBrand.id}`}
                        otherProps={{
                          width: 60,
                          height: 60,
                          className: styles.brandThumbnail,
                          onClick: isCamperOne ? () => onCustomize(false, productBrand.id) : () => true,
                        }}
                      />
                    </a>
                  </div>)}
              </div>
          </div>
        }
        { /* productSheet.textDiscountCollection &&
            <p className={recalculating ? `${styles.textDiscount} subclaimcta` : styles.textDiscount} dangerouslySetInnerHTML={{ __html: productSheet.textDiscountCollection }} />
          */
        }
        {/* {IS_NNORMAL && productSheet.kboix === true && (
          <KboixSoles selected={kboixSoles} setSelected={setKboixSoles} />
        )} */}
        {productSheet.textDiscountCollectionOld && !voucherApplied &&
          <p className={styles.textDiscount} dangerouslySetInnerHTML={{ __html: productSheet.textDiscountCollectionOld }} />
        }
        { !recalculating && ![ null, undefined ].includes(voucherPriceText) && (!productSheet.textDiscountCollectionOld || voucherApplied) &&
          <p className={styles.textDiscount} dangerouslySetInnerHTML={{ __html: voucherPriceText }} />
        }
        {shouldShowSizes && !isAccessory &&
          <Row id="row-sizes">
            <Col span={24}>
              <div className={styles.sizesWrapper} id="sizes">
                <div className={styles.sizesTitle}>
                  <div className={styles.topWrapper}>
                    {/* En camperlab la han liado y metido todo con las tallas de US por eso hay que hacer la comprobación para que si es camperlab, apparel y pantalones mostrar (US) en vez del pais correspondiente */}
                    {IS_CAMPER ? <h3 className={styles.sizesChoose} dangerouslySetInnerHTML={{ __html: `${t('ficha.producto', `elige.talla.${productSheet.realTarget}`, `***Choose your ${productSheet.realTarget} size`)} (${productSheet.camperlab && productSheet.family === String(FAMILIES.CLOTHES) && [ 'trousers', 'shorts' ].includes(productSheet.sizesGuide?.[0]?.productType) ? 'US' : country})` }} /> : null}
                    {Array.isArray(productSheet.sizesGuide) && productSheet.sizesGuide.length > 0 ? (
                      <SizesGuide
                        target={productSheet.realTarget}
                        code={code}
                        name={productSheet?.brand?.toLowerCase()}
                        guide={productSheet.sizesGuide}
                        currentCountry={country}
                        sizeGuideInfo={sizeGuideInfo}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <SizesList
                isCamperOne={isCamperOne}
                sizes={sizes}
                defaultSelectedSize={defaultSelectedSize}
                onChange={handleSelectSize}
                isSock={isSock}
                showNotifyMe
                locale={locale}
                code={code}
                select={IS_NNORMAL || (IS_CAMPER && countriesWithSizeSelector.includes(market) && [ FAMILIES.SHOES, FAMILIES.ACCESSORIES ].includes(Number(productSheet.family)))}
                currentCountry={country}
                productSheet={productSheet}
              />
              {IS_CAMPER && !isCamperOne && limitedSizes.includes(selectedSize) && !hideFewStockMessage &&
                <p className={styles.limitedSizesLabel}>
                  * {t('ficha.producto', 'size.info.only.few')}
                </p>
              }
              {IS_CAMPER && !isCamperOne && limitedSizes?.length > 0 && (!availableSizes.includes(selectedSize) || !limitedSizes.includes(selectedSize)) &&
                <p className={styles.limitedSizesLabel}>
                  * {t('ficha.producto', 'size.info.few.standby')}
                </p>
              }
            </Col>
          </Row>
        }
        <div className={styles.stickyCol} id="sticky-col">
          {shouldShowButton && !isGiftCard ?
            <div className={styles.addToCartBtn} ref={ref}>
              {cartError &&
                <p className={styles.cartErrorText}>{cartError}</p>
              }
              {
                isFullScreen === false &&
                <AddToBagBtn
                  loading={loading === 'A' || loading === true}
                  onMouseOver={() => setIsMouseOverCartBtn(true)}
                  onMouseLeave={() => setIsMouseOverCartBtn(false)}
                  onClick={() => handleClickAddToCartBtn(true)}
                  className={isMouseOverCartBtn && (!availableSizes.includes(selectedSize) || !availablePrice) ? styles.addToCartBtnDisabled : ''}
                  label={isMouseOverCartBtn && (!availableSizes.includes(selectedSize) || !availablePrice) ?
                    t('ficha.producto', 'elije.tu.talla') :
                    addToCartLabel
                  }
                  market={market}
                  t={t}
                  setLoading={setLoading}
                  extraData={productSheet.extraData}
                  id='add-to-cart-A-desktop'
                  isMembersOnly={isMembersOnly}
                  membersOnlyVisible={modalMembersOnlyVisible}
                  setModalMembersOnlyVisible={setModalMembersOnlyVisible}
                  handleAddToCart={handleClickAddToCartBtn}
                />
              }
              {
                isFullScreen === false &&
                <AddToBagBtn
                  loading={loading === 'B' || loading === true}
                  onMouseOver={() => setIsMouseOverCartBtn(true)}
                  onMouseLeave={() => setIsMouseOverCartBtn(false)}
                  onClick={() => handleClickAddToCartBtn(true)}
                  className={isMouseOverCartBtn && (!availableSizes.includes(selectedSize) || !availablePrice) ? styles.addToCartBtnDisabled : ''}
                  label={isMouseOverCartBtn && (!availableSizes.includes(selectedSize) || !availablePrice) ?
                    t('ficha.producto', 'elije.tu.talla') :
                    addToCartLabel
                  }
                  market={market}
                  t={t}
                  setLoading={setLoading}
                  id='add-to-cart-B-desktop'
                  extraData={productSheet.extraData}
                  isMembersOnly={isMembersOnly}
                  membersOnlyVisible={modalMembersOnlyVisible}
                  setModalMembersOnlyVisible={setModalMembersOnlyVisible}
                  handleAddToCart={handleClickAddToCartBtn}
                />
              }
            </div> :
            !isGiftCard &&
              <>
                {productSheet.notifyMe && !productSheet.recycled && availablePrice &&
                  <div className={styles.notifyMe}>
                    {t('ficha.producto', `avisame.texto.${productSheet.notifyMeType}`, '***Este producto no esta a la venta en este momento, pero podemos avisarte por email en cuanto este disponible')}
                  </div>
                }
                { !productSheet.recycled && notifyMe && availablePrice ?
                  <NotifyMeButton
                    defaultSize={selectedSize}
                    targetSizeGuide={productSheet.targetSizeGuide}
                    locale={locale}
                    code={code}
                    productSheet={productSheet}
                  /> :
                  <div className={styles.noStock}>
                    {t('ficha.producto', 'sin.stock')}
                  </div>
                }
              </>
          }
          {shouldShowButton && !isGiftCard && isMobile &&
            <div id='floating-add-to-cart' className={inView ? styles.addToCartBtnFixed : `${styles.addToCartBtnFixed} ${styles.visible}`}>
              {cartError &&
                <p className={styles.cartErrorText}>{cartError}</p>
              }
              {
                isFullScreen === false &&
                <AddToBagBtn
                  loading={loading === 'A'}
                  onMouseOver={() => setIsMouseOverCartBtn(true)}
                  onMouseLeave={() => setIsMouseOverCartBtn(false)}
                  onClick={() => handleClickAddToCartBtn(true)}
                  className={isMouseOverCartBtn && (!availableSizes.includes(selectedSize) || !availablePrice) ? styles.addToCartBtnDisabled : ''}
                  label={isMouseOverCartBtn && (!availableSizes.includes(selectedSize) || !availablePrice) ?
                    t('ficha.producto', 'elije.tu.talla') :
                    addToCartLabel
                  }
                  market={market}
                  t={t}
                  setLoading={setLoading}
                  id='add-to-cart-A-mobile'
                  extraData={productSheet.extraData}
                  isMembersOnly={isMembersOnly}
                  membersOnlyVisible={modalMembersOnlyVisible}
                  setModalMembersOnlyVisible={setModalMembersOnlyVisible}
                  handleAddToCart={handleClickAddToCartBtn}
                />
              }
              {
                isFullScreen === false &&
                <AddToBagBtn
                  loading={loading === 'B'}
                  onMouseOver={() => setIsMouseOverCartBtn(true)}
                  onMouseLeave={() => setIsMouseOverCartBtn(false)}
                  onClick={() => handleClickAddToCartBtn(true)}
                  className={isMouseOverCartBtn && (!availableSizes.includes(selectedSize) || !availablePrice) ? styles.addToCartBtnDisabled : ''}
                  label={isMouseOverCartBtn && (!availableSizes.includes(selectedSize) || !availablePrice) ?
                    t('ficha.producto', 'elije.tu.talla') :
                    addToCartLabel
                  }
                  market={market}
                  t={t}
                  setLoading={setLoading}
                  extraData={productSheet.extraData}
                  id='add-to-cart-B-mobile'
                  isMembersOnly={isMembersOnly}
                  membersOnlyVisible={modalMembersOnlyVisible}
                  setModalMembersOnlyVisible={setModalMembersOnlyVisible}
                  handleAddToCart={handleClickAddToCartBtn}
                />
              }
            </div>
          }
          {
            !IS_NNORMAL && !profileData.global_e && !appmode &&
            <AddToWishlistBtn
              product={{
                productId: code,
                size: selectedSize || '',
                profile: {
                  countryId: getMarket(locale),
                  languageId: getLang(locale),
                },
              }}
              productSheet={productSheet}
              isCamperOne={isCamperOne}
            />
          }
          {IS_CAMPER ? (
            <ProductShare baseUrl={productSheet.baseUrl} code={productSheet.code} image={productSheet.image} />
          ) : null}
          {!availablePrice && reviewsCount > 0 && !productSheet.recycled && !productSheet.camperlab &&
            <div
              className={`${styles.rateWrapper} ${styles.rateWrapperNotify}`}
              onClick={onClickReviews}
            >
              <Rate
                className={styles.rateStars}
                allowHalf
                defaultValue={productSheet.rate}
                value={averageRate}
                disabled
                character={<RateSVG />}
              />
              <h3 className={styles.rateTitle}>
                {`${reviewsCount} ${t('ficha.producto', 'see.reviews')}`}
              </h3>
            </div>
          }
          <ProductInfoSection
            productSheet={{
              locale,
              guarantyInfoArray: productSheet.guarantyInfoArray,
              description: productSheet.description,
              productDescription: productSheet.productDescription,
              features: productSheet.features,
              care: productSheet.care,
              code: productSheet.code,
              prices: productSheet.prices,
              careTextArray: productSheet.careTextArray,
              careDetailsArray: productSheet.careDetailsArray,
              brand: productSheet.brand,
              nameBase: productSheet.nameBase,
              sizes,
              image: productSheet.images && productSheet.images[0] ? productSheet.images[0].lg : '',
              isCamperOne,
              isRoku,
              isRecrafted: productSheet.isRecrafted,
              isGoretex3d: productSheet.isGoretex3d,
              isObraDeArte: productSheet.isObraDeArte,
              isObraDeArteSonFortesa: productSheet.isObraDeArteSonFortesa,
              baseUrl: productSheet.baseUrl,
              camperlab: productSheet.camperlab,
              presales: productSheet.presales,
              presalesDate: productSheet.presalesDate,
              productSheetInfo: productSheet.productSheetInfo,
              recycled: productSheet.recycled,
              recycledStatus: productSheet.recycledStatus,
            }}
            isGiftCard={isGiftCard}
          />
          <Modal
            visible={showRokuWarning}
            closable={false}
            footer={null}
            width={875}
            wrapClassName={styles.rokuWarningModal}
          >
            <div className={styles.modalText}>
              <h2><b>{t('ficha.producto', 'we.are.sorry', '***¡Lo sentimos!')}</b></h2>
              <h3>{t('ficha.producto', 'roku.failed.add.to.bag', '***Alguno de los productos no se han podido añadir a la bolsa.')}</h3>
              <div className={styles.failedRokusWrapper}>
                {
                  failedRokus.map((failedItem) => (
                    <Product
                      locale={locale}
                      key={`failed-piece-${failedItem.id}`}
                      withSKU
                      squareImg
                      {...failedItem}
                      images={{ sources: [ { main: failedItem.imageBag } ] }}
                      withHover={false}
                      showPrices={false}
                    />
                  ))
                }
              </div>
              <Button onClick={() => setShowRokuWarning(false)} type='primary'>{t('ficha.producto', 'seguir.customizando')}</Button>
            </div>
          </Modal>
        </div>
      </div>
    </Col>
  );
};

ProductPurchaseCol.defaultProps = {
  isCamperOne: false,
  onCustomize: () => true,
  isGiftCard: false,
  isSock: false,
  isFullScreen: false,
  onClickReviews: () => true,
  isMobile: false,
  columnSizes: {
    xs: 24,
    md: 10,
    lg: 8,
  },
  recalculating: false,
  voucherApplied: false,
  isRoku: false,
};

ProductPurchaseCol.propTypes = {
  productSheet: object,
  averageRate: number,
  hasReviews: bool,
  locale: string,
  target: string,
  product: string,
  market: string,
  isCamperOne: bool,
  onCustomize: func,
  isGiftCard: bool,
  isSock: bool,
  onClickReviews: func,
  isFullScreen: bool,
  isMobile: bool,
  columnSizes: object,
  recalculating: bool,
  voucherApplied: bool,
  voucherPriceText: string,
  isRoku: bool,
};
export default ProductPurchaseCol;
